<template>
	<div class="accordion-container">
		<template v-for="(accItem, index) in accordion">
			<AccordionItem :key="index" :accKey="index" :title="accItem.title" :body="accItem.body" :image="accItem.file_id" :opened="index === openedIndex" @openedItem="openedItem"/>
		</template>
	</div>
</template>

<script>
import AccordionItem from '@/components/AccordionItem.vue';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';

export default {
	mixins: [staticDataLoaderMixin, contentDataLoaderMixin, featureSetLoaderMixin],
	props: {
		accid: {
			type: [String, Number],
			validator(value) {
				return Number.isInteger(Number(value));
			},
		},
	},
	components: {
		AccordionItem,
	},
	data() {
		return {
			accordion: null,
			openedIndex: -1,
		};
	},
	created() {
		const allPosts = this.getContent('posts');
		this.accordion = allPosts.filter(e => e.category_id === Number(this.accid));
	},
	methods: {
		openedItem(openedKey) {
			if (openedKey === this.openedIndex) {
				openedKey = -1;
			}
			this.openedIndex = openedKey;
		},
	},
};
</script>
